import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'hvor-paa-kroppen';
            break;
        case 'hvor-paa-kroppen':
            const injuryPartOfBody = getValueOrDefault(formConfig, formValues, 'injuryPartOfBody').value;

            if (injuryPartOfBody === 'upperbody') {
                nextPage = 'skadede-kropsdele-overkrop';
            } else if (injuryPartOfBody === 'lowerbody') {
                nextPage = 'skadede-kropsdele-underkrop';
            } else {
                nextPage = 'skadede-kropsdele-over-og-underkrop';
            }

            break;
        case 'skadede-kropsdele-overkrop':
            nextPage = 'behandlingsforloeb';
            break;
        case 'skadede-kropsdele-underkrop':
            nextPage = 'behandlingsforloeb';
            break;
        case 'skadede-kropsdele-over-og-underkrop':
            nextPage = 'behandlingsforloeb';
            break;

        case 'behandlingsforloeb':
            nextPage = 'undersoegelse';

            const stillUndergoingTests = getValueOrDefault(formConfig, formValues, 'stillUndergoingTests').value;
            if (stillUndergoingTests === 'no') {
                nextPage = 'diagnose';
            }

            break;
        case 'diagnose':
            nextPage = 'gener-fra-skade';
            break;

        case 'undersoegelse':
            nextPage = 'naeste-undersoegelse';
            break;
        case 'naeste-undersoegelse':
            nextPage = 'gener-fra-skade';
            break;

        case 'gener-fra-skade':
            nextPage = 'om-arbejdsopgaver';
            break;

        case 'om-arbejdsopgaver':
            nextPage = 'om-sygemelding';
            break;

        case 'om-sygemelding':
            nextPage = 'genoptagelse-af-arbejde';

            const areYouStillOnSickLeave = getValueOrDefault(formConfig, formValues, 'areYouStillOnSickLeave').value;
            if (areYouStillOnSickLeave === 'no') {
                nextPage = 'om-tidligere-sygemelding';
            }

            break;
        case 'genoptagelse-af-arbejde':
            nextPage = 'om-tidligere-sygemelding-1';
            break;
        case 'om-tidligere-sygemelding':
            nextPage = 'om-tidligere-sygemelding-1';
            break;
        case 'om-tidligere-sygemelding-1':
            nextPage = 'om-erhvervsarbejde';
            break;

        case 'om-erhvervsarbejde':
            const workType = getValueOrDefault(formConfig, formValues, 'workType').value;
            if (workType === 'employed') {
                nextPage = 'om-din-stilling-1';
            } else if (workType === 'selfEmployed') {
                nextPage = 'om-din-stilling-2';
            } else {
                nextPage = 'om-din-stilling-3';
            }

            break;
        case 'om-din-stilling-1':
            nextPage = 'om-fleksjob';
            break;
        case 'om-din-stilling-2':
            nextPage = 'tilfredshed-med-arbejde';
            break;
        case 'om-din-stilling-3':
            nextPage = 'tilfredshed-med-arbejde';
            break;
        case 'om-fleksjob':
            nextPage = 'tilfredshed-med-arbejde';
            break;
        case 'tilfredshed-med-arbejde':
            nextPage = 'plan-for-opstart';
            break;
        case 'plan-for-opstart':
            nextPage = 'resume';
            break;

        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
